import Vue from 'vue';
import DOMPurify from 'dompurify';

const defaultOptions = {
  ALLOWED_TAGS: ['p', 'a', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'span', 'div'],
  ALLOWED_ATTR: ['href', 'target', 'class', 'style']
};

// target, rel などをaタグに自動付与
DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
  if (node.tagName === 'A') {
    if (!node.getAttribute('target')) {
      node.setAttribute('target', '_blank');
    }
    if (!node.getAttribute('rel')) {
      node.setAttribute('rel', 'noopener');
    }
  }
});

// PR動画の埋め込み用タグで使用するサニタイズ用カスタムディレクティブ
Vue.directive('sanitize-html', {
  inserted(el, binding) {
    const html = typeof binding.value === 'string' ? binding.value : binding.value?.html ?? '';
    const options = binding.value?.options ?? defaultOptions;
    // TrustedHTMLでもinnerHTMLは問題ないはずだが、型不一致を避けるためにtoString()を使用する
    el.innerHTML = DOMPurify.sanitize(html, options).toString();
  },
  update(el, binding) {
    const html = typeof binding.value === 'string' ? binding.value : binding.value?.html ?? '';
    const options = binding.value?.options ?? defaultOptions;
    el.innerHTML = DOMPurify.sanitize(html, options).toString();
  }
});
